import { ObjectUtils } from "~app/common/utils/object-utils";
import { AtgardStatusBase, IAtgardStatus, IAtgardStatusTooltip } from "./atgardheadericons-models";

export class RiskbedomningAtgardStatus extends AtgardStatusBase implements IAtgardStatus {
    header = "Riskbedömning";
    tooltips = this.getTooltips();
    icons = [
        {
            visible: true,
            iconclass1: "fas fa-exclamation",
            incomplete: false,
            warning: true
        }
    ];

    visible(): boolean {
        return ObjectUtils.hasValue(this.status.extraKartinfo?.renskotselOmraden) ||
            ObjectUtils.hasValue(this.status.extraKartinfo?.fjallnara) ||
            ObjectUtils.hasValue(this.status.extraKartinfo?.iflOmrade);
    }

    getTooltips(): IAtgardStatusTooltip[] {
        return [
            {
                header: "Åtgärden är inom renskötselområde - säkerställ om det är åretruntmark eller vinterbetesområde.",
                text: this.status.extraKartinfo.renskotselOmraden,
                visible: ObjectUtils.hasValue(this.status.extraKartinfo.renskotselOmraden),
                iconClass: "fas fa-exclamation"
            },
            {
                header: "Åtgärd är inom IFL (IntactForestLandscape)",
                text: this.status.extraKartinfo.iflOmrade ? "Ja" : "Nej",
                visible: this.status.extraKartinfo.iflOmrade
            },
            {
                header: "Åtgärd är inom Sveaskogs fjällnära gräns",
                text: this.status.extraKartinfo.fjallnara ? "Ja" : "Nej",
                visible: this.status.extraKartinfo.fjallnara
            }
        ];
    }
}
